// extracted by mini-css-extract-plugin
export var button = "_13-0";
export var buttonContent = "_13-e";
export var buttonGroup = "_13-c";
export var dontRestrainIconWidth = "_13-a";
export var dropdownButton = "_13-b";
export var iconContainer = "_13-9";
export var lg = "_13-4";
export var md = "_13-3";
export var pending = "_13-f";
export var sm = "_13-2";
export var spinner = "_13-d";
export var squared = "_13-8";
export var wrapText = "_13-g";
export var xl = "_13-5";
export var xs = "_13-1";
export var xxl = "_13-6";
export var xxxl = "_13-7";